
























































































import Vue from 'vue'
import BasePageTemplate from '@/views/templates/africadogs/BasePageTemplate.vue'
import TalkArea from '@/views/molecules/TalkAreaAfricaDogs.vue'
import ScrollFire from '@/views/mixin/ScrollFire'
import ReshowQuiz from '@/views/atoms/ReshowQuiz'
import PopupSecondQuiz from '@/views/templates/africadogs/PopupSecondQuiz.vue'
import Scope from '@/views/atoms/Scope.vue'
import MovieButton from '@/views/templates/africadogs/atoms/MovieButton.vue'
import PopupCircleEpisode from '@/views/templates/africadogs/PopupCircleEpisode.vue'
import PopupEpisode1_1 from '@/views/templates/africadogs/PopupEpisode1_1.vue'

Vue.mixin(ScrollFire)

export default
  components: {
    BasePageTemplate
    TalkArea
    ReshowQuiz
    PopupSecondQuiz
    Scope
    MovieButton
    PopupCircleEpisode
    PopupEpisode1_1
  }

  data: () ->
    labels: [
      {
        image: '/assets/image/africadogs/illust_nakasuup1.png'
        name: '中須さん'
        text: [
          '「みんなが笑って過ごせる世界をつくる」ため金融機関を退職した僕は、京都の手描き友禅の職人西田さんとともに様々な挑戦をしてきたんだ。'
        ]
      }
      {
        image: '/assets/image/africadogs/illust_nakasuup1.png'
        name: '中須さん'
        text: [
          'そうだよ！このポロシャツはその通過点となる特別な作品で、世界的なコレクションブランドでも採用されたこともある染色技法の彩纈染め（さいけつぞめ）を取り入れて染め上げているんだ。'
        ]
      }
      {
        image: '/assets/image/africadogs/illust_nakasuup2.png'
        name: '中須さん'
        text: [
          'お、スーさん、ポロシャツがよく似合ってるね！'
          '赤いアフロにもぴったりじゃないか〜'
        ]
      }
    ]
    fire_scroll: true
    showQuiz: 0
    title: [
      [
        '<strong>ポロシャツ</strong>の'
        'ポイント その1'
      ]
      [
        '<strong>ポロシャツ</strong>の'
        'ポイント その2'
      ]
    ]
    subtitle: [
      [
        '亀裂に入るグラデーションが美しい'
        '彩纈染め（さいけつぞめ）'
      ]
      [
        '職人の技術が詰め込まれた'
        '他にはない柄'
      ]
    ]
    message: [
      [
        '彩纈染め（さいけつぞめ）とは、亀裂の入る特殊な糊を使用した亀裂染めの一種です。'
        '布の上にたっぷり黒糊を塗って乾いたあとに亀裂を入れ、その亀裂に塗料を染み込ませるように染色していきます。赤と青と黄の3色を、グラデーションになるように染めていくことで、虹のような表現になっています。'
      ]
      [
        '既に購入いただいたお客さまからも「百貨店に行っても、このようなデザインのものはないし、日本の職人の技術が詰め込まれているのも斬新」と嬉しいコメントを多数いただいています。'
        'サイズはM・Lの2サイズがあります。メンズのサイズ感のため、Mは女性Lサイズ、Lは女性XLサイズ相当です。'
      ]
    ]
    images: [
      '/assets/image/africadogs/episode3_popup_01.png'
      '/assets/image/africadogs/episode3_popup_02.png'
    ]
    points: [
      'p3-9'
      'p3-10'
    ]
    targetID: -1
    showMovie: false
    isSuccess: false
    youtubeURL: 'https://www.youtube.com/embed/mOq1UsceQ5M'

  created: () ->
    @$options.scroll_target = '.episode3'

  methods: {
    startScrollFire: (e) ->
      if @showQuiz == 0
        @showQuiz = 1
    reshowQuiz: () ->
      @showQuiz = 1
    closeQuiz: () ->
      if @isSuccess
        @showQuiz = 3
      else
        @showQuiz = 2
    showPopup: (id) ->
      @targetID = id
    closePopup: () ->
      @targetID = -1
    addPoint: (point) ->
      @$emit('addPoint', point)
    openYoutube: () ->
      window.open @youtubeURL
    success: () ->
      @isSuccess = true
  }

